import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_question.png'
import _imports_1 from '@/assets/images/icon_user_line.png'
import _imports_2 from '@/assets/images/icon_language_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5f67bd2a")

_pushScopeId("data-v-5f67bd2a")
const _hoisted_1 = { class: "mypagefoodsrankingcontentfoodsrankingcard" }
const _hoisted_2 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-top" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-leftarea" }, null, -1)
const _hoisted_4 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-title" }
const _hoisted_5 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-title-text" }
const _hoisted_6 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-rightarea" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-rightarea-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-leftspace" }, null, -1)
const _hoisted_10 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content" }
const _hoisted_11 = {
  key: 0,
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-rank"
}
const _hoisted_12 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-rank-title" }
const _hoisted_13 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-rank-title-text" }
const _hoisted_14 = {
  key: 1,
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-noimagerank"
}
const _hoisted_15 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-noimagerank-title" }
const _hoisted_16 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-noimagerank-title-text" }
const _hoisted_17 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents" }
const _hoisted_18 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-image",
  src: _imports_1
}, null, -1)
const _hoisted_20 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-title" }
const _hoisted_21 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-title-text" }
const _hoisted_22 = {
  key: 0,
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items"
}
const _hoisted_23 = {
  key: 1,
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content-badge"
}
const _hoisted_24 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content-badge-text" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "mypagefoodsrankingcontentfoodsrankingcard-card-betweencontents" }, [
  /*#__PURE__*/_createVNode("div", { class: "mypagefoodsrankingcontentfoodsrankingcard-card-betweencontents-line" })
], -1)
const _hoisted_26 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents" }
const _hoisted_27 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-image",
  src: _imports_2
}, null, -1)
const _hoisted_29 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-title" }
const _hoisted_30 = { class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-rowtitle-title-text" }
const _hoisted_31 = {
  key: 0,
  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "commonCard mypagefoodsrankingcontentfoodsrankingcard-card",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickArea(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cardTitle), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "mypagefoodsrankingcontentfoodsrankingcard-card-top-rightarea-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickQuestion(...args)))
          }, [
            _hoisted_7
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankArray, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item",
              key: item.id
            }, [
              (_ctx.isValidRankImage)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    (_ctx.isValidRankImage)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "mypagefoodsrankingcontentfoodsrankingcard-card-columntitle-content-item-rank-image",
                          src: item.image
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("span", _hoisted_13, _toDisplayString(item.rankText), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("span", _hoisted_16, _toDisplayString(item.rankText), 1)
                    ])
                  ]))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _createVNode("span", _hoisted_21, _toDisplayString(_ctx.userTitleText), 1)
          ])
        ]),
        (_ctx.personalFoodList)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personalFoodList, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item",
                  key: item.foodId
                }, [
                  _createVNode("div", {
                    class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content",
                    style: _ctx.styleFoodItemSize
                  }, [
                    (item.isValidItem)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content-image",
                          src: item.image,
                          onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                        }, null, 40, ["src"]))
                      : _createCommentVNode("", true),
                    (item.isValidItem)
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _createVNode("span", _hoisted_24, _toDisplayString(item.consumeCount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 4)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_25,
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("div", _hoisted_29, [
            _createVNode("span", _hoisted_30, _toDisplayString(_ctx.nationwideTitleText), 1)
          ])
        ]),
        (_ctx.nationwideFoodList)
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nationwideFoodList, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item",
                  key: item.foodId
                }, [
                  _createVNode("div", {
                    class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content",
                    style: _ctx.styleFoodItemSize
                  }, [
                    (item.isValidItem)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "mypagefoodsrankingcontentfoodsrankingcard-card-contents-items-item-content-image",
                          src: item.image,
                          onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                        }, null, 40, ["src"]))
                      : _createCommentVNode("", true)
                  ], 4)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})